export type DiligenceUploadStage = 'prepare' | 'transfer' | 'finalize';

export class DiligenceUploadFailure extends Error {
  readonly stage: DiligenceUploadStage;
  readonly errorKind?: string;
  readonly requestId?: string;
  readonly status?: number;

  constructor(
    message: string,
    details: {
      stage: DiligenceUploadStage;
      errorKind?: string;
      requestId?: string;
      status?: number;
      cause?: unknown;
    }
  ) {
    super(message, details.cause === undefined ? undefined : { cause: details.cause });
    this.name = 'DiligenceUploadFailure';
    this.stage = details.stage;
    this.errorKind = details.errorKind;
    this.requestId = details.requestId;
    this.status = details.status;
  }
}

export function isDiligenceUploadFailure(error: unknown): error is DiligenceUploadFailure {
  return error instanceof DiligenceUploadFailure;
}

export async function createDiligenceUploadHttpFailure(
  response: Response,
  stage: DiligenceUploadStage,
  fallbackMessage: string
) {
  const payload = await response.json().catch(() => null) as {
    error?: unknown;
    errorKind?: unknown;
    requestId?: unknown;
  } | null;
  const headerKind = response.headers.get('X-Juris-Error-Kind');
  const headerRequestId = response.headers.get('X-Juris-Request-Id');
  const errorKind = headerKind
    || (typeof payload?.errorKind === 'string' ? payload.errorKind : undefined)
    || (typeof payload?.error === 'string' ? payload.error : undefined);
  const requestId = headerRequestId
    || (typeof payload?.requestId === 'string' ? payload.requestId : undefined);

  return new DiligenceUploadFailure(fallbackMessage, {
    stage,
    errorKind,
    requestId,
    status: response.status
  });
}
